import baseUrl from './baseUrl';
import isTokenExpired from '../helpers/isTokenExpired';

const ENDPOINT = `${baseUrl}/acoesterritoriais`;

function checkToken() {
    const token = window.localStorage.getItem('token');

    if (token) {
        if (isTokenExpired(token)) {
          window.localStorage.clear();
          window.location.replace('/');

          return isTokenExpired(token);
        }
    }
}

export const acoesTerritoriaisService = {
    async getAcaoTerritorial(id) {
        const data = await fetch(`${ENDPOINT}/${id}`, {
            method: 'GET',
            headers: {
                'Content-type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            },
        });

        const response = await data.json();

        return response;
    },
    async allAcoesTerritoriais(pageNumber = 1, limit = 20, filterBy = 'createdAt', orderBy = 'desc') {
        if (checkToken()) return;

        const data = await fetch(
            `${ENDPOINT}?page=${pageNumber}&limit=${limit}&filterBy=${filterBy}&orderBy=${orderBy}`, {
                method: 'GET',
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                },
            }
        );

        const response = await data.json()

        return response;
    },
    async usuariosAcaoTerritorial(id) {
        const data = await fetch(`${ENDPOINT}/${id}/usuarios`, {
            method: 'GET',
            headers: {
                'Content-type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            },
        });

        const response = await data.json();

        return response;
    },
    async update(id, values) {
        const data = await fetch(`${ENDPOINT}/${id}`, {
            method: 'PUT',
            headers: {
                'Content-type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            },
            body: JSON.stringify(values)
        });

        const response = await data.json();
        return response;
    },
    async delete(id) {
        const response = await fetch(`${ENDPOINT}/${id}`, {
            method: 'DELETE',
            headers: {
                'Content-type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            },
        });

        return response;
    },
    async create(data) {
        const response = await fetch(ENDPOINT, {
            method: 'POST',
            headers: {
                'Content-type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            },
            body: JSON.stringify(data)
        });

        return response;
    },
    async createAtividade(id, data) {
        const response = await fetch(`${ENDPOINT}/atividades/${id}`, {
            method: 'POST',
            headers: {
                'Content-type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            },
            body: JSON.stringify(data)
        });

        return response;
    },
    async updateAtividade(idAT, id, values) {
        const data = await fetch(`${ENDPOINT}/atividades/${idAT}/${id}`, {
            method: 'PUT',
            headers: {
                'Content-type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            },
            body: JSON.stringify(values)
        });

        const response = await data.json();
        return response;
    },
    async addUsuarioAT(idAT, id) {
        const data = await fetch(`${ENDPOINT}/${idAT}/${id}`, {
            method: 'PATCH',
            headers: {
                'Content-type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            },
        });

        const response = await data.json();
        return response;
    },
    async buscaUsuarios(campo, valor, cripto = false) {
        const data = await fetch(`${ENDPOINT}/busca?campo=${campo}&valor=${valor}&cripto=${cripto}`, {
            method: 'GET',
            headers: {
                'Content-type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            },
        });

        const response = await data.json();
        return response;
    },
    async usuarioAcoes(uuid) {
        const data = await fetch(`${ENDPOINT}/acoes/${uuid}`, {
            method: 'GET',
            headers: {
                'Content-type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            },
        });

        const response = await data.json();
        return response;
    },
    async patchStatus(id, status) {
        const data = await fetch(`${ENDPOINT}/status/${id}`, {
            method: 'PATCH',
            headers: {
                'Content-type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            },
            body: JSON.stringify(status)
        });

        const response = await data.json();
        return response;
    },
    async relatorio(territorio, date = '') {
        const data = await fetch(`${ENDPOINT}/relatorio?territorio=${territorio}&data=${date}`, {
            method: 'GET',
            headers: {
                'Content-type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            },
        });

        const response = await data.json();
        return response;
    }
}